import React from 'react';
import { Link } from 'react-router-dom';


// image
import Abd1 from '../../images/home/water-tank1.png'

const about = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="wpo-about-section-wrapper">
                    <div className="row align-items-center">
                        <div className="col-xl-6 col-lg-12 col-md-12 col-12">
                            <div className="wpo-about-img">
                                <div >
                                    <img src={Abd1} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-12 col-md-12 col-12">
                            <div className="wpo-about-content ">
                                <div className="wpo-about-content-top">
                                    <h2>We are a trusted polymer processing company</h2>
                                    <p>SNBS INDUSTRIES PRIVATE LIMITED is one of the fastest growing company in polymer processing in maharashtra state and known for quality, commitment and passion to serve the customers.</p>
                                </div>
                                <div className="wpo-about-content-progress">
                                    <div className="progress-inner">
                                        {/* <div className="progress yellow">
                                            <span className="progress-left">
                                                <span className="progress-bar"></span>
                                            </span>
                                            <span className="progress-right">
                                                <span className="progress-bar"></span>
                                            </span>
                                            <div className="progress-value">98%</div>
                                            <div className="progress-name"><span>Success</span></div>
                                        </div> */}
                                    </div>
                                    <p>We offer a range of Pp woven fabric, pp woven bags, Flexo printed Pp woven bags, Bopp bag, PP laminated kraft paper bag, Leno bag, corrugated box and Blow Moulded water tank.  </p>
                                </div>
                                {/* <div className="wpo-about-check-wrap">
                                    <div className="wpo-about-check-item">
                                        <p>Trusted for delivering high-quality PP woven and packaging products.</p>
                                    </div>
                                    <div className="wpo-about-check-item">
                                        <p>Committed to customer satisfaction with timely and reliable service.</p>
                                    </div>
                                </div> */}
                                <Link onClick={ClickHandler} to="#" className="theme-btn-s2">Know More</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default about;

